export const returnProtectionAppearanceTabs = {
  digitalProduct: 'digitalProduct',
  widgetAndPopup: 'widgetAndPopup',
}

export const returnProtectionAppearanceTabList = [
  { label: 'Producto digital', value: returnProtectionAppearanceTabs.digitalProduct },
  { label: 'Widget y popup', value: returnProtectionAppearanceTabs.widgetAndPopup },
]

export const returnProtectionProductPrice = 1.99

export const previewCurrency = 'EUR'

export const acceptedImageTypes = 'image/png, image/jpeg, image/jpg'
